import type { PixelTrackingEndpoint } from '@core/tracking'

export const EMBED_INSTANCE: PixelTrackingEndpoint = {
  url: '/trk/agent_status:embed_instance',
  isUserEngagement: false,
  consent: 'essential',
}

export const EMBED_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/agent_status:embed_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const CLICK_WIDGET: PixelTrackingEndpoint = {
  url: '/trk/agent_status:click_widget',
  isUserEngagement: true,
  consent: 'essential',
}
